import React, { useEffect, useState, useRef } from "react";
import { Button, Theme, makeStyles } from "@material-ui/core";
import clsx from "clsx";

import JsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import html2canvas from "html2canvas";

import { useHistory, useParams } from "react-router-dom";
import { DialogActions, DialogContent, Dialog, Divider, IconButton } from "@material-ui/core";
import { createStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import DropdownSelectOption, { SelectItemType } from "../vehicle/DropdownSelectOption";

import api from "../../store/api";

interface IParams {
    recordid: string | undefined;
}

const CHART_TYPES = [
    {
        value: 1,
        text: "Charts",
    },
    {
        value: 2,
        text: "Div layout",
    },
    {
        value: 3,
        text: "URL",
    },
    {
        value: 4,
        text : "Misc"
    }
];

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        flexDirection: "row",
        margin: 50,
    },
    legend: {
        display: "flex",
        flexDirection: "column",
    },
    singleRow: {
        display: "flex",
        flexDirection: "column",
    },
    cell: {
        width: "70px",
        height: "40px",
        display: "flex",
        border: "1px solid #000",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: 600,
    },
    redBg: {
        backgroundColor: "#d56c6a",
        color: "white",
    },
    cellWrapper: {
        cursor: "pointer",
        width: "70px",
        height: "40px",
        border: "1px solid #000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    dot: {
        width: 15,
        height: 15,
        borderRadius: "50%",
        backgroundColor: "#000",
    },
    textValueWrapper: {
        border: "1px solid #000",
        position: "relative",
        zIndex: 1000,
        backgroundColor: "#d56c6a",
    },
    textValue: {
        color: "#000",
        padding: "5px 19px",
    },
    inputField: {
        width: "37px",
        background: "#ddd",
    },
    yellowBoxText: {
        background: "#0049a3",
        padding: "6px 16px",
        fontSize: 14,
        fontWeight: 700,
        color: "#FFF",
        borderRadius: 4,
        cursor: "pointer",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "flex",
        justifyContent: "center",
    },
    buttons: {
        display: "block",
        marginTop: 20,
        marginLeft: 40,
        padding: "10px",
    },
}));

const COLUMNS = [
    {
        id: 1,
        text: "1",
    },
    {
        id: 2,
        text: "2",
    },
    {
        id: 3,
        text: "3",
    },
    {
        id: 4,
        text: "4",
    },
    {
        id: 5,
        text: "5",
    },
    {
        id: 6,
        text: "6",
    },
];

const ROWS = [
    {
        id: "r1",
        text: ">34",
        red: true,
    },
    {
        id: "r2",
        text: "30-34",
        red: true,
    },
    {
        id: "r3",
        text: "20-24",
    },
    {
        id: "r4",
        text: "15-19",
    },
    {
        id: "r5",
        text: "10-14",
    },
];

const LinesLayer = ({ refs, parentRef }: any) => {
    const [lines, setLines] = useState();

    useEffect(() => {
        // setTimeout(() => {
        const notNullRefs = refs.filter((r: any) => r !== null);
        const linesLoc: any = [];
        notNullRefs.forEach((r: any, i: any) => {
            try {
                if (i !== 0) {
                    const prevEl = notNullRefs[i - 1];

                    const x1 = prevEl.current.offsetLeft + prevEl.current.offsetWidth / 2;
                    const y1 = prevEl.current.offsetTop + prevEl.current.offsetHeight / 2;

                    const x2 = r.current.offsetLeft + r.current.offsetWidth / 2;
                    const y2 = r.current.offsetTop + r.current.offsetHeight / 2;

                    const pW = parentRef.current.offsetLeft;
                    const pH = parentRef.current.offsetTop;

                    const w = Math.abs(x1 - x2);
                    const h = Math.abs(y1 - y2);

                    const l = Math.sqrt(w * w + h * h);
                    let angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);
                    const rotateStr = `rotate(${angle}deg)`;

                    //   console.log("prevEl", prevEl);

                    linesLoc.push(
                        <div
                            style={{
                                backgroundColor: "#000",
                                height: "4px",
                                width: l,
                                position: "absolute",
                                left: x1 - pW,
                                top: y1 - pH,
                                transform: rotateStr,
                                transformOrigin: "top left",
                            }}
                            key={i}
                        ></div>
                    );
                }
                setLines(linesLoc);
            } catch { }
        });
        // }, 100);
    }, [refs, parentRef]);

    return <div>{lines}</div>;
};

const ClickableCell = ({ selected, setSelected, setSelectedRef, isRed, cellTextValue, updateTextValue }: any) => {
    const classes = useStyles();
    const itemRef = useRef(null);

    const [showInputField, setShowInputField] = useState(false);
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        if (selected) {
            setSelectedRef(itemRef);
        }
    }, []);

    const clickHandler = () => {
        if (isRed && !selected) {
            setShowInputField(true);
        } else {
            setSelected(itemRef);
        }
    };

    const handleSaveInput = () => {
        if (inputValue !== "") {
            updateTextValue(inputValue);
            setInputValue("");
            setSelected(itemRef);
        }
        setShowInputField(false);
    };

    return (
        <div
            className={clsx(classes.cellWrapper, {
                [classes.redBg]: isRed,
            })}
            onClick={clickHandler}
        >
            {selected && !isRed && !showInputField && <div className={classes.dot} ref={itemRef}></div>}
            {selected && isRed && !showInputField && (
                <div className={classes.textValueWrapper} ref={itemRef}>
                    <span className={classes.textValue}>{cellTextValue}</span>
                </div>
            )}
            {showInputField && (
                <input
                    type="text"
                    autoFocus
                    value={inputValue}
                    className={classes.inputField}
                    onChange={(e) => setInputValue(e.target.value)}
                    onBlur={handleSaveInput}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSaveInput();
                        }
                    }}
                />
            )}
        </div>
    );
};

function EmrPoc(): JSX.Element {
    const classes = useStyles();

    const history = useHistory();

    const [selectedCellsIndexes, setSelectedCellsIndexes] = useState([-1, -1, 1, -1, 0, 2]);
    const [selectedCellsRefs, setSelectedCellsRefs] = useState([null, null, null, null, null, null]);
    const [cellNumberValues, setCellNumberValues] = useState([null, null, "32", null, "38", null]);
    const [downloadingPDF, setDownloadingPDF] = React.useState(false);
    const [downloadPdf, setDownloadPdf] = React.useState<boolean>(false);
    const [chartType, setChartType] = useState<string | number>(CHART_TYPES[0].value);
    const { recordid } = useParams<IParams>();

    const selectCell = (columnIndex: number, rowIndex: number, newRef: any) => {
        const newArr = [...selectedCellsIndexes];
        const newRefsArr = [...selectedCellsRefs];
        if (newArr[columnIndex] === rowIndex) {
            newArr[columnIndex] = -1;
            newRefsArr[columnIndex] = null;
        } else {
            newArr[columnIndex] = rowIndex;
            newRefsArr[columnIndex] = newRef;
        }
        setSelectedCellsIndexes(newArr);
        setSelectedCellsRefs(newRefsArr);
    };

    const selectCellRef = (columnIndex: number, newRef: any) => {
        setSelectedCellsRefs((prev) => {
            const newRefsArr = [...prev];
            newRefsArr[columnIndex] = newRef;
            return newRefsArr;
        });
    };

    const YellowBox = ({ title, childComp = null, onClick = null, ...rest }: any) => {
        const classes = useStyles();
        if (!title) return null;
        return (
            <span onClick={onClick} className={classes.yellowBoxText} {...rest}>
                {childComp || title}
            </span>
        );
    };

    const useStylesdownloadPdf = makeStyles((theme: Theme) =>
        createStyles({
            dialogTitle: {
                marginLeft: 20,
                fontWeight: "bold",
            },
            dialogText: {
                fontSize: 20,
                fontWeight: "bold",
                color: "#333333",
                marginTop: 10,
                marginBottom: 0,
            },
            dialogMsg: {
                fontSize: 20,
                opacitiy: 0.5,
                marginTop: 5,
                fontWeight: 400,
                color: "#333333",
                textAlign: "justify",
            },
            textContainer: {
                display: "flex",
                alignItems: "flex-start",
            },
            dialogTitleContainer: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            },
            closeBtn: {
                marginRight: 15,
            },
        })
    );

    const DownloadPopUp = ({ isDialogOpen = false, onClick, recordId, downloadPdf, childComp }: any) => {
        const classes = useStylesdownloadPdf();
        return (
            <Dialog
                open={isDialogOpen}
                onClose={() => onClick(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth="sm"
            >
                <div className={classes.dialogTitleContainer}>
                    <h2 className={classes.dialogTitle}>Download PDF</h2>
                    <IconButton className={classes.closeBtn} onClick={() => onClick(false)}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <Divider />

                <DialogContent>
                    <div className={classes.textContainer}>
                        <p className={classes.dialogMsg}>
                            Select chart type: <br />1 for IronPDF chart,
                            <br /> 2 for x-arrows chart
                            <DropdownSelectOption
                                title={"Select chart type"}
                                selectedValue={chartType}
                                itemsList={CHART_TYPES}
                                onChange={(s) => {
                                    setChartType(s);
                                }}
                            />
                            Note: There might be a large number of pages in the generated pdf file.
                        </p>
                    </div>
                </DialogContent>

                <DialogActions style={{ justifyContent: "space-between" }}>
                    <Button onClick={() => onClick(false)} style={{ backgroundColor: "#ececec" }}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={() => downloadPdf({ recordId })}>
                        {childComp || "Download"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    const downloadRecord = ({ recordId }: { recordId: string | undefined }) => {
        setDownloadingPDF(true);

        //hard-coded record id
        recordId = "9721A7A1-BE30-4AD5-9BAB-000221AE3059";
        //let chartType = 1;

        api
            .generateEmrPocPdf(`recordId=${recordId}&chartType=${chartType}`, null)
            .then((res) => {
                const link = document.createElement("a");
                link.href = `data:application/pdf;base64,${res}`;
                link.download = `${recordId}`;
                link.click();
            })
            .catch((err) => {
                alert(err.toString());
            })
            .finally(() => {
                setDownloadingPDF(false);
                setDownloadPdf(false);
            });
    };
    const generatePDF = () => {
        //const doc = new JsPDF('portrait', 'pt', 'a4');
        const doc = new JsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
        try {
            const htmlData = document.querySelector<HTMLElement>('#report')!;
            if (htmlData !== null) {
                //console.log(htmlStr);
                doc.html(htmlData).then(() => {
                    doc.save("test.pdf");
                });
            }
        } catch (err) {
            console.error(err);
        }
    };

    const generateImagePDF = () => {
        const doc = new JsPDF({ orientation: "landscape", unit: "pt", format: "letter" });
        //window.html2canvas = html2canvas;
        try {
            const htmlData = document.querySelector<HTMLElement>('#report')!;
            if (htmlData !== null) {
                doc.setFontSize(12);
                doc.html(htmlData, {
                    callback: function (doc) {
                        doc.save("test.pdf");
                    },
                });
            }
        } catch (err) {
            console.error(err);
        }
    };

    const exportImagePDF = () => {
        const doc = new JsPDF({ orientation: "landscape", unit: "pt", format: "letter" });
        try {
            const htmlData = document.querySelector<HTMLElement>('#report')!;
            if (htmlData !== null) {
                html2canvas(htmlData).then((canvas) => {
                    const imgData = canvas.toDataURL("image/png");

                    var width = 840; //doc.internal.pageSize.getWidth();
                    var height = 120; //doc.internal.pageSize.getHeight();

                    doc.addImage(imgData, "png", 100, 100, width, height);
                    doc.save("test.pdf");
                });
            }
        } catch (err) {
            console.error(err);
        }
    };

    function SubHeader() {
        return (
            <div className={classes.buttons}>
                <div style={{ justifyContent: "left", display: "block", float: "left" }}>
                    <YellowBox title="Export/backend" onClick={() => setDownloadPdf(true)} style={{ marginRight: 10, minWidth: 64 }} />
                </div>
                <div style={{ justifyContent: "left", display: "block", float: "left" }}>
                    <YellowBox title="Export/frontend" onClick={() => generatePDF()} style={{ marginRight: 10, minWidth: 64 }} />
                </div>
                <div style={{ justifyContent: "left", display: "block", float: "left" }}>
                    <YellowBox title="Export/frontend (image)" onClick={() => exportImagePDF()} style={{ marginRight: 10, minWidth: 64 }} />
                </div>
            </div>
        );
    }

    const parentRef = useRef(null);

    return (
        <div>
            <SubHeader />
            <div id="report" className={classes.root}>
                <div className={classes.legend}>
                    {ROWS.map((r) => {
                        return (
                            <div
                                className={clsx(classes.cell, {
                                    [classes.redBg]: r.red,
                                })}
                                key={r.id}
                            >
                                {r.text}
                            </div>
                        );
                    })}
                </div>
                {COLUMNS.map((c, columnIndex) => {
                    return (
                        <div className={classes.singleRow} key={c.id}>
                            {ROWS.map((r, rowIndex) => {
                                return (
                                    <React.Fragment key={`${r.id}${c.id}`}>
                                        <ClickableCell
                                            selected={selectedCellsIndexes[columnIndex] === rowIndex}
                                            setSelected={(newRef: any) => {
                                                selectCell(columnIndex, rowIndex, newRef);
                                            }}
                                            setSelectedRef={(newRef: any) => {
                                                selectCellRef(columnIndex, newRef);
                                            }}
                                            cellTextValue={selectedCellsIndexes[columnIndex] === rowIndex && cellNumberValues[columnIndex]}
                                            updateTextValue={(newVal: string) => {
                                                setCellNumberValues((prev) => {
                                                    const newRefsArr = [...prev];
                                                    newRefsArr[columnIndex] = newVal;
                                                    return newRefsArr;
                                                });
                                            }}
                                            isRed={r.red}
                                        />
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    );
                })}

                <div style={{ position: "absolute" }} ref={parentRef}>
                    <LinesLayer refs={selectedCellsRefs} parentRef={parentRef} />
                </div>

                <DownloadPopUp
                    childComp={downloadingPDF ? <CircularProgress style={{ color: "white", width: 30, height: 30 }} /> : null}
                    isDialogOpen={downloadPdf}
                    onClick={setDownloadPdf}
                    recordId={recordid}
                    downloadPdf={downloadRecord}
                />
            </div>
        </div>
    );
}

export default EmrPoc;
